import { useState, useEffect } from "react";
import { MessageThread } from "@/pages/Messages";
import { MessageSquare } from "lucide-react";
import api from "@/lib/api";

export function JobChat({ job, user }) {
  const isAdmin = user.role === "admin";
  const [channel, setChannel] = useState(isAdmin ? "crew" : user.role);
  const [threads, setThreads] = useState([]);
  const [crewId, setCrewId] = useState(job.assigned_crew_id || "");

  useEffect(() => {
    if (!isAdmin) return;
    api.get(`/jobs/${job.id}/crew-threads`).then((r) => {
      setThreads(r.data.threads || []);
      setCrewId(r.data.assigned_crew_id || (r.data.threads?.[0]?.crew_id ?? ""));
    }).catch(() => {});
  }, [isAdmin, job.id]);

  const channels = isAdmin
    ? [["crew", job.assigned_crew_name ? `Contractor · ${job.assigned_crew_name}` : "Contractor (unassigned)"], ["client", job.client_account?.name ? `Client · ${job.client_account.name}` : "Client"]]
    : [[user.role, "Dispatch / SSS team"]];

  const crewQS = isAdmin && channel === "crew" && crewId ? `?crew_id=${crewId}` : "";
  const threadTitle = channel === "crew" && isAdmin
    ? (threads.find((t) => t.crew_id === crewId)?.name || channels.find(([k]) => k === "crew")?.[1])
    : channels.find(([k]) => k === channel)?.[1];

  return (
    <div className="space-y-3" data-testid="job-chat">
      {isAdmin && (
        <div className="flex border-2 border-zinc-800 w-fit" data-testid="job-chat-channels">
          {channels.map(([k, l]) => (
            <button key={k} data-testid={`job-chat-${k}`} onClick={() => setChannel(k)} className={`px-3 py-2 font-mono text-[11px] uppercase tracking-wide ${channel === k ? "bg-[#FF5722] text-black" : "text-zinc-400 hover:text-white"}`}>{l}</button>
          ))}
        </div>
      )}
      {isAdmin && channel === "crew" && threads.length > 0 && (
        <div className="flex items-center gap-2 flex-wrap" data-testid="crew-thread-picker">
          <span className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">Contractor thread</span>
          <select data-testid="crew-thread-select" value={crewId} onChange={(e) => setCrewId(e.target.value)}
            className="bg-black border-2 border-zinc-800 text-white font-mono text-[11px] px-2 py-1.5 focus:border-[#FF5722] outline-none">
            {threads.map((t) => (
              <option key={t.crew_id} value={t.crew_id}>{t.name}{t.current ? " (current)" : " (former)"}</option>
            ))}
          </select>
        </div>
      )}
      <p className="text-zinc-500 text-xs flex items-center gap-1.5"><MessageSquare size={13} className="text-[#FF5722]" /> {isAdmin ? (channel === "crew" ? "Private per-contractor chat — each contractor only sees their own thread, never a previous contractor's." : "Private chat with the client about this job — the contractor cannot see it.") : "Message the SSS team about this job — photos welcome."}</p>
      <MessageThread key={`${channel}-${crewId}`} meId={user.id} getUrl={`/jobs/${job.id}/chat/${channel}${crewQS}`} postUrl={`/jobs/${job.id}/chat/${channel}${crewQS}`}
        title={threadTitle} subtitle={job.address} height="h-[55vh]" />
    </div>
  );
}
